module.exports = __webpack_public_path__ + "img/rugby.0559c5a4.svg";